export const VGS_COLLECT_SCRIPT_URL =
  "https://js.verygoodvault.com/vgs-collect/3.2.2/vgs-collect.js";
/** Subresource integrity for the pinned script: the browser refuses it if its
 * contents change. VGS's CDN answers with `Access-Control-Allow-Origin: *`,
 * which integrity checks need. Update both constants together. */
export const VGS_COLLECT_SCRIPT_INTEGRITY =
  "sha384-YXvleED0q049Gx5rqUHI/hOTud/jKaLiL757lVq26oVFAd9SjTDHBoOviWw6XmPo";
